import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faExternalLink } from '@fortawesome/pro-regular-svg-icons';

import { helpMenuSelector } from 'common/selectors/settings';
import { SimpleDropDown, SimpleDropDownElement } from 'components/simple-dropdown';
import { useTranslation } from 'react-i18next';

const HelpMenuComponent = ({ helpMenu }) => {
  const { t } = useTranslation();

  if (!helpMenu) {
    return null;
  }
  return (
    <SimpleDropDown
      hover="ct-control-bar__element--hover"
      icon={faQuestionCircle}
      className="ct-control-bar__element"
      data-e2e="ct-help-menu"
      aria-label={t('help-menu')}
    >
      {helpMenu.map((element) => (
        <SimpleDropDownElement key={element.url} data-e2e={`menu-item-${element.label}`}>
          <button
            type="button"
            className="link-button ct-control-bar__element--no-decoration"
            onClick={() => window.open(!element.url.includes('//') ? `//${element.url}` : element.url, '_blank')}
          >
            {element.label} <FontAwesomeIcon icon={faExternalLink} className="ct-control-bar__external-link" />
          </button>
        </SimpleDropDownElement>
      ))}
    </SimpleDropDown>
  );
};

export const HelpMenu = connect(
  (state) => ({
    helpMenu: helpMenuSelector(state),
  }),
  {}
)((props) => <HelpMenuComponent {...props} />);
